import { z } from 'zod'

export const COACHING_SHELL_DASHBOARD_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellDashboardResponseSchema = z.unknown()
export type CoachingShellDashboardResponse = z.infer<typeof coachingShellDashboardResponseSchema>
